<template>
  <div id="Road">
    <div class="head">
      <div class="left">
        <span>连续出现</span>
        <Input @on-change="markContinuous" v-model="count" placeholder style="width: 60px" />
        <span>次以上</span>
        <Select v-model="select" style="width:60px">
          <Option value="zhong">中</Option>
          <Option value="fa">发</Option>
          <Option value="bai">白</Option>
        </Select>
        <Button type="primary" style="margin:0 5px" @click="markContinuous">确认</Button>
        <span>出现的次数为：{{selectRes}}</span>
      </div>
      <div class="right">
        <span>今天累计:</span>
        <span class="red">{{formatKey(key)}}</span>
        <span>中({{statisRoadNum('zhong')?statisRoadNum('zhong'):0}})</span>
        <span>发({{statisRoadNum('fa') ? statisRoadNum('fa'):0}})</span>
        <span>白({{statisRoadNum('bai') ? statisRoadNum('bai'):0}})</span>
        <span class="red">{{data.name}}</span>
        <span class="red">最新</span>
        <span class="tobottom"></span>
      </div>
    </div>
    <div class="con">
      <ul ref="lists">
        <li
          v-for="(it,i) in data[key]"
          :class="[`color${i % 2}`,{'mark':mark === it.key && it.value >= count}]"
          :key="i"
        >
          <p v-for="(is,j) in it.value" :key="j">{{formatBf(it.key)}}</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "Road",
  // props: ["data", "rank", "road", "ranks", "roads"],
  props: ["data", "betType"],

  computed: {
    reverseData() {
      return this.data.data.arrs.reverse();
    },
    statisRoad() {
      var arr = [];
      // var k =
      var resuilt = [
        { key: "", value: 0 },
        { key: "", value: 0 },
        { key: "", value: 0 }
      ];
      var d = this.data[this.key];
      for (let i = 0; i < d.length; i++) {
        const e = d[i];
        if (!arr.includes(e.key)) {
          arr.push(e.key);
        }
      }
      for (let i = 0; i < d.length; i++) {
        const e = d[i];
        arr.map((v, i) => {
          if (e.key == v) {
            resuilt[i].key = v;
            resuilt[i].value += e.value;
          }
        });
      }
      // console.log(resuilt, "resuilt");

      return resuilt;
    }
  },
  data() {
    return {
      balls: [],
      count: 1,
      select: "zhong",
      selectRes: 0,
      key: "",
      mark: ""
    };
  },
  created() {
    this.dataInit();
  },
  methods: {
    statisRoadNum(key) {
      let a = this.statisRoad;
      for (let i = 0; i < a.length; i++) {
        const e = a[i];
        if (e.key == key) {
          return e.value;
        }
      }
    },
    dataInit() {
      this.balls = this.setBall(1, 8);
      this.key = Object.keys(this.data)[0];
      // console.log(this.key, "ssssss");
    },
    formatBf(key) {
      return {
        zhong: "中",
        bai: "白",
        fa: "发"
      }[key];
    },
    setBall(start, len) {
      let res = [];
      for (let i = start; i <= len; i++) {
        if (this.betType == "hpten") {
          res.push({
            name: `号码${i}`,
            key: `ball${i}`
          });
        }
      }
      return res;
    },
    formatKey(key) {
      let name;
      this.balls.map(v => {
        if (v.key == key) {
          name = v.name;
        }
      });
      return name;
    },
    formatValue(key) {
      return {
        中: "zhong",
        白: "bai",
        发: "fa"
      }[key];
    },
    markContinuous() {
      this.mark = this.select;
      this.$nextTick(() => {
        let len = this.$refs.lists.getElementsByClassName("mark").length;
        this.selectRes = len;
      });
    }
  }
};
</script>
<style lang="less" scoped>
@media screen and (max-width: 1200px) {
  #Road {
    width: 100% !important;
  }
}
#Road {
  width: 1140px;
  margin: 0 auto;
  margin-bottom: 20px;
  overflow-x: auto;
  .head {
    min-width: 1080px;
    border: 1px solid #e6e6e6;
    background-color: #f5f5f5;
    height: 43px;
    font-size: 14px;
    color: #555;
    span {
      margin: 0 5px;
    }
    .left {
      float: left;
      display: flex;
      align-items: center;
      height: 100%;
      padding-left: 10px;
    }
    .right {
      height: 100%;
      float: right;
      display: flex;
      align-items: center;

      .red {
        color: rgb(241, 2, 11);
      }
      .tobottom {
        width: 20px;
        height: 38px;
        padding: 0;
        background: url("../../../assets/img/bjpknum.png") no-repeat -257px -235px;
      }
    }
  }
  .con {
    min-width: 1080px;
    min-height: 130px;
    border: 1px solid #e6e6e6;
    border-top: 0;
    background: url("../../../assets/img/table_bg.png") repeat;
    ul {
      width: 100%;
      overflow: hidden;
      display: flex;
      justify-content: flex-end;
      overflow-x: auto;
    }
    li {
      flex: none;
      min-height: 130px;
      width: 30px;
      flex-shrink: 0;
      text-align: center;
      font-weight: normal;

      &:nth-last-child(2n) {
        background-color: #fff;
      }
      &:nth-last-child(2n-1) {
        background-color: #f5f5f5;
      }

      &:nth-last-child(1) p:nth-last-child(1) {
        font-weight: bold;
      }
      &.mark {
        background-color: rgb(253, 173, 86);
        color: #fff;
      }
      &.color1 {
        color: rgb(241, 2, 11);
        &.mark {
          color: rgb(241, 2, 11);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Trend/zhongfabailuzhu/Road.vue